(()=>{
  const initializedWorlds=new WeakSet();
  const initWorld=world=>{
    if(initializedWorlds.has(world))return;
    initializedWorlds.add(world);
    const girl=world.querySelector('[data-sae-girl]');
    const room=world.querySelector('[data-sae-room]');
    const panels=[...world.querySelectorAll('[data-sae-panel]')];
    const tags=world.querySelector('[data-sae-tags]');
    const radios=[...world.querySelectorAll('[name="sae_preference"]')];
    const rail=world.querySelector('[data-sae-garment-rail]');
    const cards=rail?[...rail.querySelectorAll('[data-sae-wear]')]:[];
    const dots=world.querySelector('[data-sae-closet-dots]');
    const tagMap={store:'SAEROU password page, SAEROU store notes',magazine:'SAEROU password page, SAE Magazine only',everything:'SAEROU password page, SAEROU everything'};
    let closetIndex=0,autoTimer=null,drag=null,lastX=0,pageIndex=0;

    const open=name=>{
      panels.forEach(panel=>panel.hidden=panel.dataset.saePanel!==name);
      const panel=world.querySelector(`[data-sae-panel="${name}"]`);
      if(panel){panel.hidden=false;setTimeout(()=>panel.querySelector('button,input')?.focus(),20);}
      if(name==='dress')setTimeout(()=>selectCard(closetIndex,false),50);
    };
    const closePanel=target=>target.closest('[data-sae-panel]')?.setAttribute('hidden','');
    const storage={get:key=>{try{return localStorage.getItem(key)}catch(_){return null}},set:(key,value)=>{try{localStorage.setItem(key,value)}catch(_){}}};

    const selectCard=(index,scroll=true)=>{
      if(!cards.length)return;
      closetIndex=(index+cards.length)%cards.length;
      cards.forEach((card,i)=>card.classList.toggle('is-current',i===closetIndex));
      dots?.querySelectorAll('i').forEach((dot,i)=>dot.classList.toggle('is-current',i===closetIndex));
      if(scroll)cards[closetIndex].scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
    };
    if(dots)cards.forEach((_,i)=>{const dot=document.createElement('i');dot.classList.toggle('is-current',i===0);dots.append(dot);});
    const nearestCard=()=>{
      if(!rail||!cards.length)return;
      const center=rail.scrollLeft+rail.clientWidth/2;
      let nearest=0,distance=Infinity;
      cards.forEach((card,i)=>{const d=Math.abs(card.offsetLeft+card.offsetWidth/2-center);if(d<distance){distance=d;nearest=i;}});
      selectCard(nearest,false);
    };
    rail?.addEventListener('scroll',()=>requestAnimationFrame(nearestCard),{passive:true});
    const pauseAuto=()=>{clearInterval(autoTimer);autoTimer=null;};
    const startAuto=()=>{pauseAuto();autoTimer=setInterval(()=>selectCard(closetIndex+1),3200);};
    ['pointerdown','touchstart','mouseenter','focusin'].forEach(type=>rail?.addEventListener(type,pauseAuto,{passive:true}));
    ['pointerup','touchend','mouseleave','focusout'].forEach(type=>rail?.addEventListener(type,()=>setTimeout(startAuto,1800),{passive:true}));
    startAuto();

    const wearCard=card=>{
      if(!card)return;
      const layer=world.querySelector(`[data-sae-garment-layer="${card.dataset.saeWear}"]`);
      if(!layer)return;
      const willShow=layer.hidden;
      if(willShow&&card.hasAttribute('data-sae-exclusive')){
        world.querySelectorAll('[data-sae-garment-layer]').forEach(item=>item.hidden=true);
        cards.forEach(button=>button.classList.remove('is-selected'));
      }else if(willShow){
        world.querySelectorAll('.sae-garment--dress,.sae-garment--suspender').forEach(item=>item.hidden=true);
        world.querySelectorAll('[data-sae-exclusive]').forEach(button=>button.classList.remove('is-selected'));
      }
      layer.hidden=!willShow;
      card.classList.toggle('is-selected',willShow);
    };

    world.addEventListener('click',event=>{
      const saeControl=event.target.closest('[data-sae-start],[data-sae-begin],[data-sae-open],[data-sae-close],[data-sae-wear],[data-sae-wear-selected],[data-sae-clear-look],[data-sae-closet-prev],[data-sae-closet-next],[data-sae-page],[data-sae-print]');
      if(!saeControl)return;
      event.preventDefault();
      event.stopPropagation();
      if(event.target.closest('[data-sae-start]')){
        world.classList.add('is-started');
        if(storage.get('sae-skip-welcome')!=='1')setTimeout(()=>open('welcome'),520);
      }
      if(event.target.closest('[data-sae-begin]')){
        if(world.querySelector('[data-sae-skip-welcome]')?.checked)storage.set('sae-skip-welcome','1');
        closePanel(event.target);
      }
      const opener=event.target.closest('[data-sae-open]');
      if(opener){
        const preference=opener.dataset.saePreference;
        if(preference){const radio=world.querySelector(`[name="sae_preference"][value="${preference}"]`);if(radio){radio.checked=true;tags.value=tagMap[preference];}}
        open(opener.dataset.saeOpen);
      }
      if(event.target.closest('[data-sae-close]'))closePanel(event.target);
      const card=event.target.closest('[data-sae-wear]');
      if(card){selectCard(cards.indexOf(card));wearCard(card);}
      if(event.target.closest('[data-sae-wear-selected]'))wearCard(cards[closetIndex]);
      if(event.target.closest('[data-sae-clear-look]')){world.querySelectorAll('[data-sae-garment-layer]').forEach(layer=>layer.hidden=true);cards.forEach(button=>button.classList.remove('is-selected'));}
      if(event.target.closest('[data-sae-closet-prev]'))selectCard(closetIndex-1);
      if(event.target.closest('[data-sae-closet-next]'))selectCard(closetIndex+1);
      const pageButton=event.target.closest('[data-sae-page]');
      if(pageButton)turnPage(pageButton.dataset.saePage==='next'?1:-1);
      if(event.target.closest('[data-sae-print]'))window.print();
    },true);

    if(location.hash==='#sae-mail'||world.querySelector('[data-sae-success]')){world.classList.add('is-started');open('mail');}
    radios.forEach(radio=>radio.addEventListener('change',()=>tags.value=tagMap[radio.value]));
    const pages=[...world.querySelectorAll('.sae-page')],pageNumber=world.querySelector('[data-sae-page-number]');
    const turnPage=direction=>{if(!pages.length)return;pageIndex=(pageIndex+direction+pages.length)%pages.length;pages.forEach((page,index)=>page.classList.toggle('is-current',index===pageIndex));if(pageNumber)pageNumber.textContent=String(pageIndex+1).padStart(2,'0');};

    girl?.addEventListener('pointerdown',event=>{if(event.button!==undefined&&event.button!==0)return;event.preventDefault();event.stopPropagation();const rect=girl.getBoundingClientRect();drag={dx:event.clientX-rect.left,dy:event.clientY-rect.top,pointerId:event.pointerId};lastX=event.clientX;try{girl.setPointerCapture(event.pointerId)}catch(_){}girl.classList.add('is-dragging','is-walking');},{passive:false,capture:true});
    girl?.addEventListener('pointermove',event=>{if(!drag||event.pointerId!==drag.pointerId)return;event.preventDefault();const roomRect=room.getBoundingClientRect(),girlRect=girl.getBoundingClientRect(),delta=event.clientX-lastX;if(Math.abs(delta)>1)girl.classList.toggle('is-facing-left',delta<0);lastX=event.clientX;let x=event.clientX-drag.dx-roomRect.left,y=event.clientY-drag.dy-roomRect.top;x=Math.max(-girlRect.width*.08,Math.min(x,roomRect.width-girlRect.width*.92));y=Math.max(0,Math.min(y,roomRect.height-girlRect.height));girl.style.left=`${x/roomRect.width*100}%`;girl.style.top=`${y/roomRect.height*100}%`;girl.style.bottom='auto';},{passive:false,capture:true});
    const stop=event=>{if(drag&&event?.pointerId!==undefined&&event.pointerId!==drag.pointerId)return;try{if(drag&&girl?.hasPointerCapture(drag.pointerId))girl.releasePointerCapture(drag.pointerId)}catch(_){}drag=null;girl?.classList.remove('is-dragging','is-walking');};
    girl?.addEventListener('pointerup',stop,true);girl?.addEventListener('pointercancel',stop,true);window.addEventListener('blur',stop);document.addEventListener('visibilitychange',()=>{if(document.hidden)stop()});
    const clock=world.querySelector('[data-sae-clock]'),tick=()=>{if(clock)clock.textContent=new Intl.DateTimeFormat([],{hour:'2-digit',minute:'2-digit'}).format(new Date());};tick();setInterval(tick,30000);
  };
  const initAll=root=>(root.matches?.('[data-sae-world]')?[root]:[...root.querySelectorAll?.('[data-sae-world]')||[]]).forEach(initWorld);
  const boot=()=>initAll(document);
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',boot,{once:true}):boot();
  window.addEventListener('load',boot,{once:true});
  window.addEventListener('pageshow',boot);
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)boot();});
  document.addEventListener('shopify:section:load',event=>initAll(event.target));
  new MutationObserver(records=>records.forEach(record=>record.addedNodes.forEach(node=>{if(node.nodeType===1)initAll(node)}))).observe(document.documentElement,{childList:true,subtree:true});
  let bootAttempts=0;
  const bootRetry=setInterval(()=>{boot();bootAttempts+=1;if(bootAttempts>=20||document.querySelector('[data-sae-world]'))clearInterval(bootRetry);},250);
})();
